import { useMemo } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { useDuration } from './useDuration';

export const useMidrollCues = () => {
  const player = usePlayer();
  const { duration } = useDuration();

  const jw = player.getJWPlayer();
  const cues = jw?.getCues();

  const midrolls = useMemo(() => {
    if (duration > 0 && cues) {
      return cues
        .filter((cue) => cue.cueType === 'ads')
        .map((cue) => {
          const percentage =
            typeof cue.begin === 'number'
              ? (cue.begin / duration) * 100
              : cue.begin === 'post'
                ? 100
                : 0;

          return {
            ...cue,
            percentage,
          };
        });
    }

    return [];
  }, [cues, duration]);

  return { midrolls };
};
